











































import { DateTime } from "luxon";
import { Component, Ref, Vue, Watch } from "vue-property-decorator";
import DateField from "@/components/misc/DateField.vue";
import { Action, Getter } from "vuex-class";
import { ContingentDateSpans, ContingentSettings } from "@/store/modules/contingent";
import { JwtClaims } from "@/store/modules/auth";

@Component({ components: { DateField } })
export default class TimeTrackNav extends Vue {
  @Getter("language/language") language?: string;

  @Getter("contingent/isLoading") loading?: boolean;
  @Getter("contingent/currentDay") currentDay?: DateTime;
  @Action("contingent/goToDay") goToDay?: (payload: DateTime) => void;
  @Getter("contingent/months") months?: string;
  @Getter("contingent/settings") settingsList?: ContingentSettings[];
  @Getter("auth/claims") claims?: JwtClaims;

  dateFieldModel = this.formatDateForPicker(DateTime.local());

  @Watch("currentDay", { immediate: true })
  currentChanged(fresh: DateTime) {
    this.dateFieldModel =
      this.formatDateForPicker(fresh) ?? this.formatDateForPicker(DateTime.local());
  }

  @Watch("dateSpan")
  dateSpanChanged() {
    if(this.currentDay) {
      this.dateFieldModel =
        this.formatDateForPicker(this.currentDay) ?? this.formatDateForPicker(DateTime.local());
    }
  }

  selected(evt: string) {
    if (this.goToDay) {
      try {
        this.goToDay(DateTime.fromISO(evt));
      } catch {
        this.$store.dispatch("showNotification", {
          color: "error",
          message: this.$t("Selected date is not a valid ISODate"),
          timeout: 5000,
        });
      }
    }
  }

  get currentTenantId() {
    return this.claims ? +this.claims.tid : 0;
  }

  get currentUserId() {
    return this.claims ? +this.claims.sid : 0;
  }

  get currentSettings() {
    const settings = this.settingsList?.find(x => x.userId == this.currentUserId && x.tenantId == this.currentTenantId);
    if (settings) {
      return settings;
    }
    return this.settingsList?.find((x) => x.userId == 0);
  }
  get dateSpan(): ContingentDateSpans {
    return this.currentSettings?.dateSpan ?? "month";
  }

  get datePickerType() {
    let toReturn = '';
    switch (this.currentSettings?.dateSpan) {
        case 'year':
            toReturn = 'year';
            break;

        case 'month':
            toReturn = 'month';
            break;

        case 'week':
            toReturn = 'date';
            break;

        default:
            toReturn = 'month';
            break;
    }

    return toReturn
  }

  get activeDatePicker() {
    let toReturn = '';
    switch (this.currentSettings?.dateSpan) {
        case 'year':
            toReturn = 'YEAR';
            break;

        case 'month':
            toReturn = 'MONTH';
            break;

        case 'week':
            toReturn = 'DATE';
            break;

        default:
            toReturn = 'MONTH';
            break;
    }

    return toReturn
  }

  // If we dont format, date picker wont show current selected date/month/year
  // this forma is tied to activeDatePicker value
  formatDateForPicker(date: DateTime) {
    let toReturn = '';
    switch (this.currentSettings?.dateSpan) {
        case 'year':
            toReturn = date.toISODate().substring(0, 7);
            break;

        case 'month':
            toReturn = date.toISODate().substring(0, 7);
            break;

        case 'week':
            toReturn = date.toISODate();
            break;

        default:
            toReturn = date.toISODate().substring(0, 7);
            break;
    }

    return toReturn
  }

  /* Vuetify has a bug where it retains focus, :retain-focus-on-click="false" doesn't fix it 
  https://github.com/vuetifyjs/vuetify/issues/3125#issuecomment-527843283 */
  @Ref("navRightBtn") navRightBtn?: Vue;
  navRight() {
    if (this.navRightBtn?.$el instanceof HTMLElement) {
      this.navRightBtn?.$el.blur();
    }
    if (this.goToDay && this.currentDay) {
      switch (this.currentSettings?.dateSpan) {
        case 'year':
          this.goToDay(this.currentDay.plus({ years: 1 }));
          break;

        case 'month':
          this.goToDay(this.currentDay.plus({ months: 1 }));
          break;

        case 'week':
          this.goToDay(this.currentDay.plus({ weeks: 1 }));
          break;

        default:
          this.goToDay(this.currentDay.plus({ months: 1 }));
          break;
      }
    }
  }
  @Ref("navLeftBtn") navLeftBtn?: Vue;
  navLeft() {
    if (this.navLeftBtn?.$el instanceof HTMLElement) {
      this.navLeftBtn?.$el.blur();
    }
    if (this.goToDay && this.currentDay) {
      switch (this.currentSettings?.dateSpan) {
        case 'year':
          this.goToDay(this.currentDay.minus({ years: 1 }));
          break;

        case 'month':
          this.goToDay(this.currentDay.minus({ months: 1 }));
          break;

        case 'week':
          this.goToDay(this.currentDay.minus({ weeks: 1 }));
          break;

        default:
          this.goToDay(this.currentDay.minus({ months: 1 }));
          break;
      }
    }
  }
}
